// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
  color: var(--ca-text-primary, #172033);
}

.breadcrumb {
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.breadcrumb-nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1.25rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.875rem;
}

.breadcrumb-link {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--ca-primary, #0e2e80);
  font: inherit;
  text-decoration: none;
  cursor: pointer;
}
.breadcrumb-link:hover {
  color: var(--ca-primary-dark, #0d2863);
  text-decoration: underline;
}
.breadcrumb-link:focus-visible {
  outline: 3px solid rgba(40, 80, 173, 0.25);
  outline-offset: 3px;
  border-radius: var(--ca-radius-sm, 6px);
}

.breadcrumb-link i {
  font-size: 1.25rem;
}

.breadcrumb-separator {
  color: var(--ca-text-muted, #8c96a8);
}

.breadcrumb-current {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 500;
}

.breadcrumb-current i {
  font-size: 1.25rem;
}

.dashboard-page {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;
  color: var(--ca-text-primary, #172033);
}

.dashboard-breadcrumbs {
  margin-bottom: 1.15rem;
}

.dashboard-heading {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  margin: 0.25rem 0 2rem;
}

.dashboard-heading-copy {
  min-width: 0;
}

.dashboard-eyebrow {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 0.55rem;
  color: var(--ca-primary-light, #2850ad);
  font-size: 0.7rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.eyebrow-mark {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 2px;
  background: var(--ca-primary-light, #2850ad);
  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);
}

.dashboard-heading h1 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.65rem, 2.4vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.045em;
  line-height: 1.2;
}

.dashboard-subtitle {
  max-width: 740px;
  margin: 0.65rem 0 0;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.9rem;
  line-height: 1.65;
}

.dashboard-context {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 0 auto;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.context-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid #d8e3ff;
  border-radius: var(--ca-radius-md, 8px);
  background: #eef3ff;
  color: var(--ca-primary, #0e2e80);
  font-size: 1.05rem;
}

.dashboard-context > div {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.context-label {
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.68rem;
  font-weight: 650;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.dashboard-context strong {
  color: var(--ca-text-primary, #172033);
  font-size: 0.82rem;
  font-weight: 700;
  white-space: nowrap;
}

.metrics-section {
  margin-bottom: 1.65rem;
}

.section-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 0.9rem;
}

.section-intro h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 1.05rem;
  font-weight: 750;
  letter-spacing: -0.015em;
}

.section-intro p {
  margin: 0.25rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.8rem;
}

.metrics-count,
.panel-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: 999px;
  background: var(--ca-surface, #fff);
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem;
  font-weight: 650;
  white-space: nowrap;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.metric-card {
  position: relative;
  display: flex;
  min-width: 0;
  min-height: 200px;
  flex-direction: column;
  overflow: hidden;
  padding: 1.15rem 1.2rem 1.05rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.metric-card:hover {
  transform: translateY(-2px);
  border-color: var(--ca-border, #dfe4ec);
  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));
}

.metric-topline {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.65rem;
  margin-bottom: 1.1rem;
}

.metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  flex: 0 0 2.55rem;
  border-radius: 0.8rem;
  font-size: 1.1rem;
}

.metric-card--healthy .metric-icon {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-card--updated .metric-icon {
  background: var(--ca-warning-bg, #fff7e6);
  color: #b97700;
}

.metric-card--source .metric-icon {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-card--failures .metric-icon {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-status {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.28rem 0.5rem;
  border-radius: 999px;
  font-size: 0.66rem;
  font-weight: 700;
  white-space: nowrap;
}

.metric-status > span {
  width: 0.35rem;
  height: 0.35rem;
  border-radius: 50%;
  background: currentColor;
}

.metric-status--success {
  background: var(--ca-success-bg, #eaf7f0);
  color: var(--ca-success, #198754);
}

.metric-status--info {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.metric-status--primary {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.metric-status--danger {
  background: var(--ca-danger-bg, #fdecef);
  color: var(--ca-danger, #dc3545);
}

.metric-copy {
  min-width: 0;
}

.metric-copy h3 {
  margin: 0 0 0.35rem;
  color: var(--ca-text-secondary, #4b5870);
  font-size: 0.8rem;
  font-weight: 650;
  line-height: 1.4;
}

.metric-value {
  overflow: hidden;
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: clamp(1.75rem, 2vw, 2.15rem);
  font-weight: 750;
  letter-spacing: -0.05em;
  line-height: 1.2;
  text-overflow: ellipsis;
}

.metric-unit {
  margin-left: 0.15rem;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0;
}

.metric-value--source {
  display: -webkit-box;
  min-height: 2.45rem;
  overflow: hidden;
  font-size: clamp(1rem, 1.3vw, 1.25rem);
  letter-spacing: -0.025em;
  line-height: 1.25;
  overflow-wrap: anywhere;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.metric-description {
  margin: 0.45rem 0 0;
  color: var(--ca-text-muted, #8c96a8);
  font-size: 0.72rem;
  line-height: 1.4;
}

.metric-description strong {
  color: var(--ca-text-secondary, #4b5870);
  font-weight: 750;
}

.metric-accent {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 3px;
  opacity: 0.8;
}

.metric-card--healthy .metric-accent {
  background: var(--ca-success, #198754);
}

.metric-card--updated .metric-accent {
  background: #d98c00;
}

.metric-card--source .metric-accent {
  background: var(--ca-primary-light, #2850ad);
}

.metric-card--failures .metric-accent {
  background: var(--ca-danger, #dc3545);
}

.dashboard-panels {
  display: grid;
  grid-template-columns: minmax(0, 1.02fr) minmax(0, 1.18fr);
  gap: 1.15rem;
  align-items: stretch;
}

.dashboard-panel {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 1.15rem;
  border: 1px solid var(--ca-border-light, #e9edf3);
  border-radius: var(--ca-radius-lg, 12px);
  background: var(--ca-surface, #fff);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}

.panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--ca-border-light, #e9edf3);
}

.panel-heading-copy {
  min-width: 0;
}

.panel-title-line {
  display: flex;
  align-items: center;
  gap: 0.65rem;
}

.panel-title-line h2 {
  margin: 0;
  color: var(--ca-text-primary, #172033);
  font-size: 0.98rem;
  font-weight: 750;
  line-height: 1.4;
}

.panel-heading-copy > p {
  margin: 0.45rem 0 0;
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.76rem;
  line-height: 1.5;
}

.panel-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.15rem;
  height: 2.15rem;
  flex: 0 0 2.15rem;
  border-radius: 0.65rem;
  font-size: 0.95rem;
}

.panel-icon--chart {
  background: var(--ca-surface-active, #eef3ff);
  color: var(--ca-primary, #0e2e80);
}

.panel-icon--table {
  background: var(--ca-info-bg, #eaf6fc);
  color: var(--ca-info, #1d7fbf);
}

.panel-tag {
  margin-top: 0.1rem;
  background: var(--ca-bg, #f5f7fb);
}

.chart-content {
  position: relative;
  min-width: 0;
  height: 330px;
  padding-top: 1rem;
}

.chart-content canvas {
  display: block;
  width: 100% !important;
  height: 100% !important;
}

.summary-table-content {
  min-width: 0;
  padding-top: 1rem;
}

.summary-table-content app-report-table {
  display: block;
  min-width: 0;
  width: 100%;
}

@media (max-width: 1200px) {
  .metrics-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-panels {
    grid-template-columns: minmax(0, 1fr);
  }
  .chart-content {
    height: 320px;
  }
}
@media (max-width: 767.98px) {
  .dashboard-page {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .dashboard-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
  }
  .dashboard-context {
    width: 100%;
  }
  .section-intro {
    align-items: flex-start;
  }
  .metrics-count {
    display: none;
  }
  .metric-card {
    min-height: 185px;
    padding: 1rem;
  }
  .dashboard-panel {
    padding: 0.9rem;
  }
  .panel-header {
    align-items: flex-start;
  }
  .panel-tag {
    display: none;
  }
  .chart-content {
    height: 280px;
  }
}
@media (max-width: 480px) {
  .metrics-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .metric-card {
    min-height: auto;
  }
  .metric-topline {
    margin-bottom: 0.8rem;
  }
  .metric-value {
    font-size: 1.9rem;
  }
  .metric-value--source {
    min-height: 0;
    font-size: 1.1rem;
  }
  .panel-title-line {
    align-items: flex-start;
  }
  .panel-title-line h2 {
    padding-top: 0.15rem;
  }
  .chart-content {
    height: 250px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .metric-card {
    transition: none;
  }
  .metric-card:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/asset-management/auth-tools/asset-management-dashboard/asset-management-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,sCAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EACE,sCAAA;EACA,0BAAA;AACJ;AAEE;EACE,0CAAA;EACA,mBAAA;EACA,uCAAA;AAAJ;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,oCAAA;AADF;;AAIA;EAEE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;AAFF;;AAKA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,sCAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,WAAA;EACA,sBAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4CAAA;EACA,uDAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,yCAAA;EACA,gBAAA;EACA,wBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,uCAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAFF;;AAKA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,uCAAA;EACA,iBAAA;AAFF;;AAKA;;EAEE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,iDAAA;EACA,oBAAA;EACA,mCAAA;EACA,uCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,+BAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;EACA,6EAAA;AAFF;;AAKA;EACE,2BAAA;EACA,uCAAA;EACA,iEAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,qBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,iCAAA;AAFF;;AAKA;EACE,yCAAA;EACA,cAAA;AAFF;;AAKA;EACE,6CAAA;EACA,iCAAA;AAFF;;AAKA;EACE,wCAAA;EACA,gCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,iCAAA;AAFF;;AAKA;EACE,sCAAA;EACA,8BAAA;AAFF;;AAKA;EACE,6CAAA;EACA,iCAAA;AAFF;;AAKA;EACE,wCAAA;EACA,gCAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,mBAAA;EACA,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,SAAA;EACA,sCAAA;EACA,uCAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sCAAA;EACA,wBAAA;EACA,iBAAA;EACA,uBAAA;EACA,4BAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,wCAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,sCAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,4CAAA;AAFF;;AAKA;EACE,qCAAA;AAFF;;AAKA;EACE,aAAA;EACA,0DAAA;EACA,YAAA;EACA,oBAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,iDAAA;EACA,wCAAA;EACA,mCAAA;EACA,gEAAA;AAFF;;AAKA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,wDAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAFF;;AAKA;EACE,SAAA;EACA,sCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,6CAAA;EACA,iCAAA;AAFF;;AAKA;EACE,sCAAA;EACA,8BAAA;AAFF;;AAKA;EACE,kBAAA;EACA,iCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,sBAAA;EACA,uBAAA;AAFF;;AAKA;EACE,YAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AAFF;;AAKA;EACE;IACE,gDAAA;EAFF;EAKA;IACE,qCAAA;EAHF;EAMA;IACE,aAAA;EAJF;AACF;AAOA;EACE;IACE,qBAAA;IACA,oBAAA;EALF;EAQA;IACE,uBAAA;IACA,sBAAA;IACA,SAAA;IACA,qBAAA;EANF;EASA;IACE,WAAA;EAPF;EAUA;IACE,uBAAA;EARF;EAWA;IACE,aAAA;EATF;EAYA;IACE,iBAAA;IACA,aAAA;EAVF;EAaA;IACE,eAAA;EAXF;EAcA;IACE,uBAAA;EAZF;EAeA;IACE,aAAA;EAbF;EAgBA;IACE,aAAA;EAdF;AACF;AAiBA;EACE;IACE,qCAAA;EAfF;EAkBA;IACE,gBAAA;EAhBF;EAmBA;IACE,qBAAA;EAjBF;EAoBA;IACE,iBAAA;EAlBF;EAqBA;IACE,aAAA;IACA,iBAAA;EAnBF;EAsBA;IACE,uBAAA;EApBF;EAuBA;IACE,oBAAA;EArBF;EAwBA;IACE,aAAA;EAtBF;AACF;AAyBA;EACE;IACE,gBAAA;EAvBF;EA0BA;IACE,eAAA;EAxBF;AACF","sourcesContent":[":host {\r\n  display: block;\r\n  min-width: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n}\r\n\r\n.breadcrumb {\r\n  margin-top: 1.5rem;\r\n  margin-left: 1.5rem;\r\n}\r\n\r\n.breadcrumb-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin: 0 0 1.25rem;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.875rem;\r\n}\r\n\r\n.breadcrumb-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  padding: 0;\r\n  border: 0;\r\n  background: transparent;\r\n  color: var(--ca-primary, #0e2e80);\r\n  font: inherit;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n\r\n  &:hover {\r\n    color: var(--ca-primary-dark, #0d2863);\r\n    text-decoration: underline;\r\n  }\r\n\r\n  &:focus-visible {\r\n    outline: 3px solid rgba(40, 80, 173, 0.25);\r\n    outline-offset: 3px;\r\n    border-radius: var(--ca-radius-sm, 6px);\r\n  }\r\n}\r\n\r\n.breadcrumb-link i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.breadcrumb-separator {\r\n  color: var(--ca-text-muted, #8c96a8);\r\n}\r\n\r\n.breadcrumb-current {\r\n  \r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-weight: 500;\r\n}\r\n\r\n.breadcrumb-current i {\r\n  font-size: 1.25rem;\r\n}\r\n\r\n.dashboard-page {\r\n  width: 100%;\r\n  max-width: 1600px;\r\n  margin: 0 auto;\r\n  padding: 0.25rem clamp(0.75rem, 2vw, 1.5rem) 2rem;\r\n  color: var(--ca-text-primary, #172033);\r\n}\r\n\r\n.dashboard-breadcrumbs {\r\n  margin-bottom: 1.15rem;\r\n}\r\n\r\n.dashboard-heading {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 1.5rem;\r\n  margin: 0.25rem 0 2rem;\r\n}\r\n\r\n.dashboard-heading-copy {\r\n  min-width: 0;\r\n}\r\n\r\n.dashboard-eyebrow {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  margin: 0 0 0.55rem;\r\n  color: var(--ca-primary-light, #2850ad);\r\n  font-size: 0.7rem;\r\n  font-weight: 800;\r\n  letter-spacing: 0.12em;\r\n}\r\n\r\n.eyebrow-mark {\r\n  width: 0.45rem;\r\n  height: 0.45rem;\r\n  border-radius: 2px;\r\n  background: var(--ca-primary-light, #2850ad);\r\n  box-shadow: 0 0 0 3px var(--ca-surface-active, #eef3ff);\r\n}\r\n\r\n.dashboard-heading h1 {\r\n  margin: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: clamp(1.65rem, 2.4vw, 2.15rem);\r\n  font-weight: 750;\r\n  letter-spacing: -0.045em;\r\n  line-height: 1.2;\r\n}\r\n\r\n.dashboard-subtitle {\r\n  max-width: 740px;\r\n  margin: 0.65rem 0 0;\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.9rem;\r\n  line-height: 1.65;\r\n}\r\n\r\n.dashboard-context {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.75rem;\r\n  flex: 0 0 auto;\r\n  padding: 0.7rem 0.9rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n}\r\n\r\n.context-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.5rem;\r\n  height: 2.5rem;\r\n  border: 1px solid #d8e3ff;\r\n  border-radius: var(--ca-radius-md, 8px);\r\n  background: #eef3ff;\r\n  color: var(--ca-primary, #0e2e80);\r\n  font-size: 1.05rem;\r\n}\r\n\r\n.dashboard-context > div {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.1rem;\r\n}\r\n\r\n.context-label {\r\n  color: var(--ca-text-muted, #8c96a8);\r\n  font-size: 0.68rem;\r\n  font-weight: 650;\r\n  letter-spacing: 0.06em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.dashboard-context strong {\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.metrics-section {\r\n  margin-bottom: 1.65rem;\r\n}\r\n\r\n.section-intro {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  margin-bottom: 0.9rem;\r\n}\r\n\r\n.section-intro h2 {\r\n  margin: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 1.05rem;\r\n  font-weight: 750;\r\n  letter-spacing: -0.015em;\r\n}\r\n\r\n.section-intro p {\r\n  margin: 0.25rem 0 0;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.metrics-count,\r\n.panel-tag {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.4rem;\r\n  padding: 0.35rem 0.6rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: 999px;\r\n  background: var(--ca-surface, #fff);\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.7rem;\r\n  font-weight: 650;\r\n  white-space: nowrap;\r\n}\r\n\r\n.metrics-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n  gap: 1rem;\r\n}\r\n\r\n.metric-card {\r\n  position: relative;\r\n  display: flex;\r\n  min-width: 0;\r\n  min-height: 200px;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  padding: 1.15rem 1.2rem 1.05rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.metric-card:hover {\r\n  transform: translateY(-2px);\r\n  border-color: var(--ca-border, #dfe4ec);\r\n  box-shadow: var(--ca-shadow-md, 0 4px 12px rgba(7, 17, 46, 0.08));\r\n}\r\n\r\n.metric-topline {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 0.65rem;\r\n  margin-bottom: 1.1rem;\r\n}\r\n\r\n.metric-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.55rem;\r\n  height: 2.55rem;\r\n  flex: 0 0 2.55rem;\r\n  border-radius: 0.8rem;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.metric-card--healthy .metric-icon {\r\n  background: var(--ca-success-bg, #eaf7f0);\r\n  color: var(--ca-success, #198754);\r\n}\r\n\r\n.metric-card--updated .metric-icon {\r\n  background: var(--ca-warning-bg, #fff7e6);\r\n  color: #b97700;\r\n}\r\n\r\n.metric-card--source .metric-icon {\r\n  background: var(--ca-surface-active, #eef3ff);\r\n  color: var(--ca-primary, #0e2e80);\r\n}\r\n\r\n.metric-card--failures .metric-icon {\r\n  background: var(--ca-danger-bg, #fdecef);\r\n  color: var(--ca-danger, #dc3545);\r\n}\r\n\r\n.metric-status {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  padding: 0.28rem 0.5rem;\r\n  border-radius: 999px;\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  white-space: nowrap;\r\n}\r\n\r\n.metric-status > span {\r\n  width: 0.35rem;\r\n  height: 0.35rem;\r\n  border-radius: 50%;\r\n  background: currentColor;\r\n}\r\n\r\n.metric-status--success {\r\n  background: var(--ca-success-bg, #eaf7f0);\r\n  color: var(--ca-success, #198754);\r\n}\r\n\r\n.metric-status--info {\r\n  background: var(--ca-info-bg, #eaf6fc);\r\n  color: var(--ca-info, #1d7fbf);\r\n}\r\n\r\n.metric-status--primary {\r\n  background: var(--ca-surface-active, #eef3ff);\r\n  color: var(--ca-primary, #0e2e80);\r\n}\r\n\r\n.metric-status--danger {\r\n  background: var(--ca-danger-bg, #fdecef);\r\n  color: var(--ca-danger, #dc3545);\r\n}\r\n\r\n.metric-copy {\r\n  min-width: 0;\r\n}\r\n\r\n.metric-copy h3 {\r\n  margin: 0 0 0.35rem;\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-size: 0.8rem;\r\n  font-weight: 650;\r\n  line-height: 1.4;\r\n}\r\n\r\n.metric-value {\r\n  overflow: hidden;\r\n  margin: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: clamp(1.75rem, 2vw, 2.15rem);\r\n  font-weight: 750;\r\n  letter-spacing: -0.05em;\r\n  line-height: 1.2;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.metric-unit {\r\n  margin-left: 0.15rem;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.95rem;\r\n  font-weight: 600;\r\n  letter-spacing: 0;\r\n}\r\n\r\n.metric-value--source {\r\n  display: -webkit-box;\r\n  min-height: 2.45rem;\r\n  overflow: hidden;\r\n  font-size: clamp(1rem, 1.3vw, 1.25rem);\r\n  letter-spacing: -0.025em;\r\n  line-height: 1.25;\r\n  overflow-wrap: anywhere;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-line-clamp: 2;\r\n}\r\n\r\n.metric-description {\r\n  margin: 0.45rem 0 0;\r\n  color: var(--ca-text-muted, #8c96a8);\r\n  font-size: 0.72rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.metric-description strong {\r\n  color: var(--ca-text-secondary, #4b5870);\r\n  font-weight: 750;\r\n}\r\n\r\n.metric-accent {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 3px;\r\n  opacity: 0.8;\r\n}\r\n\r\n.metric-card--healthy .metric-accent {\r\n  background: var(--ca-success, #198754);\r\n}\r\n\r\n.metric-card--updated .metric-accent {\r\n  background: #d98c00;\r\n}\r\n\r\n.metric-card--source .metric-accent {\r\n  background: var(--ca-primary-light, #2850ad);\r\n}\r\n\r\n.metric-card--failures .metric-accent {\r\n  background: var(--ca-danger, #dc3545);\r\n}\r\n\r\n.dashboard-panels {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1.02fr) minmax(0, 1.18fr);\r\n  gap: 1.15rem;\r\n  align-items: stretch;\r\n}\r\n\r\n.dashboard-panel {\r\n  display: flex;\r\n  min-width: 0;\r\n  flex-direction: column;\r\n  padding: 1.15rem;\r\n  border: 1px solid var(--ca-border-light, #e9edf3);\r\n  border-radius: var(--ca-radius-lg, 12px);\r\n  background: var(--ca-surface, #fff);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n}\r\n\r\n.panel-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px solid var(--ca-border-light, #e9edf3);\r\n}\r\n\r\n.panel-heading-copy {\r\n  min-width: 0;\r\n}\r\n\r\n.panel-title-line {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.65rem;\r\n}\r\n\r\n.panel-title-line h2 {\r\n  margin: 0;\r\n  color: var(--ca-text-primary, #172033);\r\n  font-size: 0.98rem;\r\n  font-weight: 750;\r\n  line-height: 1.4;\r\n}\r\n\r\n.panel-heading-copy > p {\r\n  margin: 0.45rem 0 0;\r\n  color: var(--ca-text-tertiary, #6f7b91);\r\n  font-size: 0.76rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.panel-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 2.15rem;\r\n  height: 2.15rem;\r\n  flex: 0 0 2.15rem;\r\n  border-radius: 0.65rem;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.panel-icon--chart {\r\n  background: var(--ca-surface-active, #eef3ff);\r\n  color: var(--ca-primary, #0e2e80);\r\n}\r\n\r\n.panel-icon--table {\r\n  background: var(--ca-info-bg, #eaf6fc);\r\n  color: var(--ca-info, #1d7fbf);\r\n}\r\n\r\n.panel-tag {\r\n  margin-top: 0.1rem;\r\n  background: var(--ca-bg, #f5f7fb);\r\n}\r\n\r\n.chart-content {\r\n  position: relative;\r\n  min-width: 0;\r\n  height: 330px;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.chart-content canvas {\r\n  display: block;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.summary-table-content {\r\n  min-width: 0;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.summary-table-content app-report-table {\r\n  display: block;\r\n  min-width: 0;\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n  .metrics-grid {\r\n    grid-template-columns: repeat(2, minmax(0, 1fr));\r\n  }\r\n\r\n  .dashboard-panels {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .chart-content {\r\n    height: 320px;\r\n  }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n  .dashboard-page {\r\n    padding-right: 0.5rem;\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .dashboard-heading {\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .dashboard-context {\r\n    width: 100%;\r\n  }\r\n\r\n  .section-intro {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .metrics-count {\r\n    display: none;\r\n  }\r\n\r\n  .metric-card {\r\n    min-height: 185px;\r\n    padding: 1rem;\r\n  }\r\n\r\n  .dashboard-panel {\r\n    padding: 0.9rem;\r\n  }\r\n\r\n  .panel-header {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .panel-tag {\r\n    display: none;\r\n  }\r\n\r\n  .chart-content {\r\n    height: 280px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .metrics-grid {\r\n    grid-template-columns: minmax(0, 1fr);\r\n  }\r\n\r\n  .metric-card {\r\n    min-height: auto;\r\n  }\r\n\r\n  .metric-topline {\r\n    margin-bottom: 0.8rem;\r\n  }\r\n\r\n  .metric-value {\r\n    font-size: 1.9rem;\r\n  }\r\n\r\n  .metric-value--source {\r\n    min-height: 0;\r\n    font-size: 1.1rem;\r\n  }\r\n\r\n  .panel-title-line {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .panel-title-line h2 {\r\n    padding-top: 0.15rem;\r\n  }\r\n\r\n  .chart-content {\r\n    height: 250px;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .metric-card {\r\n    transition: none;\r\n  }\r\n\r\n  .metric-card:hover {\r\n    transform: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
